/**
 * MaintainIcon — sanitized from `assets/newSvg/maintain.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function MaintainIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M14.1937,2.88504 C16.4945,2.58607 18.6518,3.09549 19.8388,4.28249 C20.6296,5.07323 21.0191,5.99325 20.9999,7.00196 C20.9815,7.96337 20.5936,8.89623 20.061,9.76635 C19.29936,11.0106333 18.1092724,12.329372 16.7917208,13.6811374 L16.0622243,14.4214903 L16.0622243,14.4214903 L14.4462642,16.037599 L14.4462642,16.037599 L13.7549026,16.7197297 C12.3773507,18.0658549 11.0332567,19.285512 9.76635,20.061 C8.89623,20.5936 7.96337,20.9815 7.00196,20.9999 C5.99325,21.0191 5.07323,20.6296 4.28249,19.8388 C3.09549,18.6518 2.58607,16.4945 2.88504,14.1937 C3.19156,11.8349 4.35621,9.15851 6.75736,6.75736 C9.15851,4.35621 11.8349,3.19156 14.1937,2.88504 Z M5.69082,11.6643 C5.32708,12.4508 5.08706,13.2212 4.94891,13.948 C5.36839,14.3077 5.86757,14.5859 6.44114,14.7771 C6.96508,14.9517 7.5314,14.6685 7.70604,14.1446 C7.88068,13.6206 7.59751,13.0543 7.07357,12.8797 C6.40714,12.6576 5.96194,12.2681 5.69082,11.6643 Z M8.69033,7.67865 C8.51641,7.83544 8.34337,7.99965 8.1715,8.17152 C7.84969,8.49333 7.55473,8.81926 7.28506,9.14734 C7.47926,9.39831 7.69121,9.63574 7.90638,9.85091 C8.49063,10.4352 9.23896,10.9956 9.97666,11.2415 C10.5006,11.4162 11.0669,11.133 11.2416,10.6091 C11.4037286,10.1225286 11.1711214,9.59948418 10.717601,9.3874195 L10.6091,9.34416 C10.2861,9.2365 9.79701,8.91311 9.3206,8.4367 C9.06213,8.17823 8.8487,7.91603 8.69033,7.67865 Z M13.1113,5.14906 C12.4928,5.32735 11.852,5.57939 11.2039,5.91717 C11.7236,6.7636 12.5026,7.36948 13.5122,7.70599 C14.0362,7.88063 14.6025,7.59746 14.7771,7.07352 C14.9517,6.54957 14.6686,5.98326 14.1446,5.80862 C13.7108,5.664 13.3707,5.44849 13.1113,5.14906 Z"
        fill={color}
      />
    </Svg>
  );
}

export default MaintainIcon;
